<template>
<!-- Sections -->
<section id="mod-benefits" :class="['pt-page','pt-page-1','mod-benefits',
    meanList[2].clicked ? 'pt-page-current' : '',
    meanList[2].leave ? 'pt-page-moveToTop pt-page-current':'',
    meanList[2].enter ? 'pt-page-scaleUp':'']"><!-- Webpartzones --><!-- Webparts -->
<div :class="['mod-section-benefits',pageClass.pageNow]">
  <div :class='["inner-section","content-first","slide","",
  currentBoolean.isTwo ? "pt-page-moveToLeft":"",
  currentBoolean.isOne ? "pt-page-scaleUp pt-slide-current":""]'>
    <div class="content-container">
      <h2><span class="first"><span class="active"><span>熟练使用各类前端框架</span></span></span><span class="second"><span class="active"><span class="anim">目前在用Vue.js、微信小程序</span></span></span></h2>
      <p class="infoText anim">
        运用各类前端框架，根据其优势和不足熟练运用到不同的项目或创业中。<br>
        JavaScript作用于浏览器，熟练使用原生JS、JQuery、Zepto对应插件及框架；JavaScript作用于WebView、内置App，熟练使用Vue、Cordova、微信小程序；JavaScript作用于服务器端，了解Node.js。
        熟练使用HTML、CSS进行页面的制作，酷炫复杂自定义动画不会。
      </p>
    </div>
  </div>
  <div :class='["inner-section","content-second","slide",
  currentBoolean.isTwo ? "pt-page-scaleUp pt-slide-current":"",
  currentBoolean.isOne ? "pt-page-moveToRight":"",
  currentBoolean.isThree ? "pt-page-moveToLeft":""]'>
    <div class="content-container">
      <h2><span class="first"><span class="active"><span>我是要成为</span></span></span><span class="second"><span class="active"><span class="anim">海贼王的男人。</span></span></span></h2>
      <p class="infoText anim">
        我是出生在一个很普通的农村家庭，从小学会做什么事必须靠自己，如果想要生活得更好，自己就必须加倍的努力。用几个词语形容自己的话，那就是：时尚屌丝、成熟的有点过分、智商超群、情商为零、做事认真负责、向往自由…
      </p>
    </div>
  </div>
  <div :class='["inner-section","content-third","slide",
  currentBoolean.isThree ? "pt-page-scaleUp pt-slide-current":""]'>
    <div class="content-container">
      <h2><span class="first"><span class="active"><span>App：一起玩吧</span></span></span><span class="second"><span class="active"><span class="anim">网站：个人博客</span></span></span></h2>
      <p class="infoText anim">
        一起玩吧：以玩会友，人这辈子真心朋友不多，希望通过该App能让大家找到真心朋友。<br>
        博客：自己的练级之地，除了前端技术方面，还有生活、健身、自己的思想等各个方面。
      </p>
    </div>
  </div>
  <div class="benefits-nav">
    <div class="benefits-nav-line">
      <span class="label left">简单介绍</span>
      <span class="line-left"></span>
      <span class="label middle">个人展示</span>
      <span class="line-right"></span>
      <span class="label right">得意作品</span>
      <span class="marker left active" @click="turnPage(0)"></span>
      <span class="marker middle" @click="turnPage(1)"></span>
      <span class="marker right" @click="turnPage(2)"></span>
      <span class="active-marker">
        <img alt="" src="/images/icons/benefits-marker-active.png">
      </span>
    </div>
    <span class="arrow arrow-left" @click="turnLeft()"><img alt="" src="/images/icons/benefits-arrow-left.png"></span>
    <span class="arrow arrow-right" @click="turnRight()"><img alt="" src="/images/icons/benefits-arrow-right.png"></span>
  </div>
</div>
</section>
</template>

<script>
export default {
  props:['pageBoolean','meanList'],
  data(){
    return{
      progressWidth:{
        width:0
      },
      pageText:{
        time:0,
        pageTexts:['first','second','third']
      },
      pageClass:{
        pageNow:'first',
        pageNowNum:0
      },
      currentBoolean:{
        isFullPlay:false,
        toggleFullPlay:false,
        toggleFullPlayMuted:false,
        isThree:false,
        isTwo:false,
        isOne:true
      }
    }
  },
  methods:{
    turnRight(){
      var index=0;
      this.pageClass.pageNowNum++;
      index=this.pageClass.pageNowNum%3;
      this.turnPage(index);
    },
    turnLeft(){
      var index=0;
      this.pageClass.pageNowNum--;
      index=this.pageClass.pageNowNum%3;
      this.turnPage(index);
    },
    turnPage(index){
      if(index == 0){
        this.currentBoolean.isOne=true;
        this.currentBoolean.isTwo=false;
        this.currentBoolean.isThree=false;
      }else if(index == 1){
        this.currentBoolean.isOne=false;
        this.currentBoolean.isTwo=true;
        this.currentBoolean.isThree=false;
      }else if(index == 2){
        this.currentBoolean.isOne=false;
        this.currentBoolean.isTwo=false;
        this.currentBoolean.isThree=true;
      }
      this.pageClass.pageNow=this.pageText.pageTexts[index];
    },
    canplay(){
      var video=document.getElementById('loopVideo');
      //console.log('可以开始播放了');
      this.pageBoolean.showLoad=false;
      video.style.width=window.innerWidth+'px';
      video.play();
    },
    toggleFullPlay(){
      var fullVideo=document.getElementById('fullVideo');
      this.currentBoolean.toggleFullPlay=!this.currentBoolean.toggleFullPlay;
      if(this.currentBoolean.toggleFullPlay){
        this.progressBarVal();
        fullVideo.pause();
      }else{
        fullVideo.play();
      }
    },
    toggleFullPlayMuted(){
      var fullVideo=document.getElementById('fullVideo');
      this.currentBoolean.toggleFullPlayMuted=!this.currentBoolean.toggleFullPlayMuted;
      fullVideo.muted=this.currentBoolean.toggleFullPlayMuted;
    },
    canFullPlay(){
      var video=document.getElementById('loopVideo'),fullVideo=document.getElementById('fullVideo');
      this.currentBoolean.isFullPlay=true;
      //console.log('大屏播放');
      video.pause();
      fullVideo.play();
    },
    closeFullPlay(){
      var video=document.getElementById('loopVideo'),fullVideo=document.getElementById('fullVideo');
      this.currentBoolean.isFullPlay=false;
      this.currentBoolean.toggleFullPlay=false;
      //console.log('关闭播放');
      fullVideo.pause();
      video.play();
    },
    progressBarVal(){
      var fullVideo=document.getElementById('fullVideo');
      //console.log(fullVideo.currentTime.toFixed(0) +'秒');
      this.pageText.time=this.showTime(fullVideo.currentTime.toFixed(0));
      this.progressWidth.width=(fullVideo.currentTime / fullVideo.duration*100).toFixed(5)+'%';
      //console.log((fullVideo.currentTime / fullVideo.duration*100).toFixed(5)+'%');
    },
    getProgressBar(e){
      var fullVideo=document.getElementById('fullVideo'),fullBar=document.getElementById('fullBar'),
      precent=(e.clientX/fullBar.clientWidth).toFixed(5),currentTime=0;
      currentTime=fullVideo.duration*precent;
      //console.log(fullVideo.duration);//总时间
      //console.log(e.clientX);//选择的长度
      //console.log(fullBar.clientWidth);//总长度
      fullVideo.currentTime=currentTime;
      //console.log(currentTime);
    },
    showTime(time){
      var timeStr="";
      if(time < 10){
        timeStr="0:0"+time;
      }else if(time < 60){
        timeStr="0:"+time;
      }else{
        if(time % 60 < 10){
          timeStr=Math.floor(time/60)+":0"+time % 60;
        }else{
          timeStr=Math.floor(time/60)+":"+time % 60;
        }
      }
      return timeStr;
    }
  }
}
</script>



// WEBPACK FOOTER //
// Advantage.vue?45237cd0